<template>
	<v-card flat class="card-patient">

		<v-col cols="6" sm="3" md="1" class="pt-5">
			<template v-if="data.ProfilePicPath">
                <img :src="data.ProfilePicPath" :alt="patientinfo.namepatient" width="50px" height="50px"/>
            </template>
            <template v-else>
                <img src="/images/logo/pets.svg" alt="Mascota sin imagen"  width="50px" height="50px">
            </template>
		</v-col>

		<v-col cols="6" sm="3" md="auto" class="pt-5">
		<p><span class="font-weight-bold">ID de Paciente:</span><br />{{ patientinfo.id_patient }}</p>
		</v-col>

		<v-col cols="6" sm="3" md="auto" class="mt-n3 mt-sm-0 pt-sm-5">
		<p><span class="font-weight-bold">Nombre del Paciente:</span> <br />{{ patientinfo.namepatient }}</p>
		</v-col>

		<v-col cols="6" sm="3" md="auto" class="mt-n3 mt-sm-0 pt-sm-5">
		<p><span class="font-weight-bold">Fecha Nac.:</span> <br />{{ patientinfo.dateofbirth }}</p>
		</v-col>

		<v-col cols="6" sm="3" md="auto" class="mt-n4 mt-md-0 pt-md-5">
		<p><span class="font-weight-bold">Especie:</span> <br />{{ patientinfo.species }}</p>
		</v-col>

		<v-col cols="6" sm="3" md="auto" class="mt-n4 mt-md-0 pt-md-5">
		<p><span class="font-weight-bold">Raza:</span> <br />{{ patientinfo.breed }}</p>
		</v-col>

		<v-col cols="6" sm="3" md="auto" class="mt-n4 mt-md-0 pt-md-5">
		<p><span class="font-weight-bold">{{ patientinfo?.customer?.Is_a_Business ? 'Empresa' : 'Dueño' }}:</span><br />{{ patientinfo?.customer?.Is_a_Business ? patientinfo.customer.BusinessName : `${patientinfo?.customer?.FirstName} ${patientinfo?.customer?.LastName}` }}</p>
		</v-col>

		<v-col cols="6" sm="3" md="auto" class="mt-n4 mt-md-0 pt-md-5">
		<p><span class="font-weight-bold">Médico actual:</span> <br />{{ `${useData?.firstName} ${useData?.lastName}` }}</p>
		</v-col>
      
	</v-card>
  </template>
  

<script>
export default {
    name: "UserProfile",
    props: ['patientinfo', 'data', 'useData'],
}

</script>
